import {Component} from '@angular/core';
import {CrPolicyProduct} from './cr/cr-policy-product';
import {ControlContainer, NgForm} from '@angular/forms';
import {PolicyContractVersionService} from '../../../../bonding_shared/services';

@Component({
  selector: 'cr-policy-product',
  templateUrl: './cr-policy-product.component.pug',
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
})
export class CrPolicyProductComponent extends CrPolicyProduct {
  constructor(policyContractVersionService: PolicyContractVersionService) {
    super(policyContractVersionService);
  }
}
